var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CommonPages',{class:['privacy-page'],attrs:{"id":"privacy","titlePrefix":_vm.pageMetaTitle,"metaDescription":_vm.pageMetaDescription}},[_c('LegalContentLayout',{attrs:{"title":"Privacy Policy"}},[_c('div',{staticClass:"legal-richtext"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.privacyBody)}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }